// Backend API URL - change this if your backend runs on a different port
const BACKEND_API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

export const getSkincareRecommendations = async (userResponses) => {
  try {
    const response = await fetch(`${BACKEND_API_URL}/api/recommendations`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userResponses),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to get recommendations from backend');
    }

    const recommendations = await response.json();
    return recommendations;

  } catch (error) {
    if (error.message.includes('fetch')) {
      throw new Error('Cannot connect to backend server. Make sure it is running.');
    }
    throw error;
  }
};
